<template>
    <div class="flex-column w-100 d-flex">
        <!-- Фикс бага с рандомным полем логина на странице -->
        <form>
            <input type="text" name="username" style="width:0;height:0;visibility:hidden;position:absolute;left:0;top:0"
                   autocomplete="username"/>
            <input type="password" style="width:0;height:0;visibility:hidden;position:absolute;left:0;top:0"
                   autocomplete="current-password"/>
        </form>

        <b-overlay :show="socketError" no-wrap>
            <template slot="overlay">
                <b-alert show variant="danger">
                    Не удалось установить соединение с сервером. Проверьте соединение с Интернетом и перезагрузите
                    страницу
                </b-alert>
            </template>
        </b-overlay>

        <b-overlay :show="chunkError" no-wrap>
            <template slot="overlay">
                <b-alert show variant="danger">
                    Не удалось загрузить страницу. Проверьте соединение с Интернетом и перезагрузите
                    страницу
                </b-alert>
            </template>
        </b-overlay>

        <b-overlay :show="authChanged" no-wrap>
            <template slot="overlay">
                <b-alert show variant="warning" dismissible @dismissed="authChanged = false" >
                    <div v-if="!isAuthenticated">
                        Вы вышли из своей учетной записи
                    </div>
                    <div v-else>
                        Вы авторизировались под другой учётной записью: {{ user && user.profile_label }}
                    </div>
                </b-alert>
            </template>
        </b-overlay>
        <div :class="{overlayed: socketError || authChanged}">

            <div class="alerts position-fixed fixed-top w-auto"></div>
            <app-header :contacts="contacts"/>
            <b-toast
                id="profile-toast"
                title="Заполните профиль!"
                variant="danger"
                toaster="b-toaster-top-center"
                no-auto-hide
                @hidden="profileToastShowed = false"
            >
                Перед началом работы необходимо заполнить
                <router-link :to="{ name: 'profile.home' }">профиль</router-link>
                и получить допуск
            </b-toast>
            <b-toast
                v-if="mustShowEcpReqToast"
                id="ecp-toast"
                title="Добавьте к профилю ЭЦП!"
                variant="warning"
                toaster="b-toaster-top-center"
                no-auto-hide
                :visible=true
            >
                Электронная цифровая подпись даст вам возможность подписывать документы,
                а так же входить без пароля. Перейдите в
                <router-link :to="{ name: 'profile.home' }"> профиле</router-link>
                на вкладку "Сертификат".
            </b-toast>
            <main class="flex-shrink-0 mb-3" role="main">
                <div class="alerts position-fixed fixed-top w-auto">
                    <flash-message/>
                </div>
                <router-view/>
                <div class="d-block d-sm-none" v-if="!$auth.check()">
                    <div class="col-12 py-3 mx-lg-4">
                        <auth-login/>
                    </div>
                </div>
            </main>
            <banners />
            <app-footer :contacts="contacts" />

        </div>
    </div>
</template>
<script>
import {library} from "@fortawesome/fontawesome-svg-core";
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons/faWhatsapp";
import {faMax} from '../customIcons/faMax'
import {faTelegram} from "@fortawesome/free-brands-svg-icons/faTelegram";
import {actions, state} from "../store";

import Banners from "../components/features/Banners";
import AppFooter from "../components/core/AppFooter";
import AppHeader from "../components/core/AppHeader";
import AuthLogin from "../components/features/Auth/AuthLogin";
import {routeToLot} from "@/helpers/router-helpers";

import {userIsAdminOperator} from "@/helpers/auth-helpers"
import * as Sentry from "@sentry/browser";

library.add(faWhatsapp, faMax, faTelegram);

    export default {
        name: "App",
        components: {
            Banners,
            AppFooter,
            AppHeader,
            AuthLogin,
        },
        data() {
            return {
                profileToastShowed: false,
                lastChannelName: null,
                currentVersion: null,
                websocketReconnecting: false,
                authChanged: false,
                chunkError: false,
            }
        },
        computed: {
            user() {
                return this.$auth?.watch?.data;
            },
            mustShowEcpReqToast() {
                // if 'user' or 'organizer' without fingerprint
                const role = this.$auth?.watch?.data?.role
                return ['organizer', 'user'].includes(role) && !this.user.fingerprint
            },
            isAuthenticated() {
                return this.$auth.check();
            },
            socketError() {
                const onceConnected = this.$store.state.Lot.socketOnceConnected
                if (!onceConnected) {
                    return false; //Если ни разу не подключились, то ошибку не показываем
                }
                if (!this.isAuthenticated) {
                    return false;
                }
                if (this.websocketReconnecting) {
                    return false;
                }
                return !this.socketAvailable
            },
            socketAvailable() {
                return this.$store.state.Lot.socketAvailable
            },
            token() {
                return this.$auth.token()
            },
            contacts() {
                return this.siteInfo
                    ? [
                        {
                            key: "phone",
                            classes: ["header__phone"],
                            value: this.siteInfo.phone,
                            href: `tel:${this.siteInfo.phone}`,
                            icon: ["fas", "phone-alt"],
                            links: [
                                {key: "whatsapp", icon: ["fab", "whatsapp"]},
                                {key: "max", icon: ["fab", "max"]},
                                {key: "telegram", icon: ["fab", "telegram"]},
                            ],
                        },
                        {
                            key: "email",
                            classes: ["header__email"],
                            value: this.siteInfo.email,
                            href: `mailto:${this.siteInfo.email}`,
                            icon: ["fas", "envelope"],
                        },
                    ]
                    : [];
            },
            siteInfo() {
                return state.siteInfo;
            },
        },
        watch: {
            //фикс авторизации после смены токена
            token(newToken) {
                // console.log("CHANGED TOKEN")
                Echo.connector.pusher.config.auth.headers["Authorization"] = "Bearer " + newToken
                this.reconnectWebsocket()
            },
            user() {
                // console.log("CHANGED USER")
                this.reconnectWebsocket()
            },
            isAuthenticated(authenticated) {
                if (authenticated) {
                    // console.log("Authenticated")
                    Echo.connector.pusher.config.auth.headers["Authorization"] = "Bearer " + this.token;
                    this.reconnectWebsocket()
                }
                this.notAcceptedMessage()
            },
            socketAvailable(connected) {
                // console.log('SOCKET AVAILABLE: ', connected)
                if (connected) {
                    this.listen();
                } else {
                    this.leave();
                }
            },
            "$route.params.message": function () {
                if (this.$route.params.message) {
                    this.$notify(this.$route.params.message, "success", {
                        timeout: 10000,
                    });
                }
            },
            $route() {
                this.updateProfile()
            },
        },
        beforeCreate() {
            actions.fetchSiteInfo()
            this.$store.dispatch('Regions/fetchList')
        },
        mounted() {
            window.addEventListener("storage", this.onStorageUpdate);
            this.$eventHub.$on('chunkError', () => {
                this.chunkError = true
                this.checkVersion()
            })
            this.currentVersion = document.head.querySelector('meta[name="version"]').content
            this.checkVersion();
        },
        beforeDestroy() {
            window.removeEventListener("storage", this.onStorageUpdate);
        },
        methods: {
            reconnectWebsocket() {
                this.checkVersion() //Переподключение к соккету обычно означает, что сервак был перезагружен
                this.websocketReconnecting = true
                this.$store.dispatch('Lot/socketUnavailable')
                this.$nextTick(() => {
                    this.$store.dispatch('Lot/socketAvailable')
                    this.websocketReconnecting = false
                })
            },
            onStorageUpdate(event) {
                if (event.key === "Authorization") {
                    // console.log("AUTH CHANGED")
                    this.refreshAuth(event.newValue)
                }
            },
            async refreshAuth(newValue) {
                this.authChanged = true
                if (newValue) {
                    await this.$auth.fetch()
                    //Без двойного вызова не работает
                    await this.$auth.fetch()
                    this.reconnectWebsocket()
                } else {
                    this.$auth.logout({
                        makeRequest: false,
                    })
                }
            },
            showProfileToast() {
                if (this.profileToastShowed) return
                this.profileToastShowed = true
                this.$bvToast.show("profile-toast")
            },
            hideProfileToast() {
                if (!this.profileToastShowed) return
                this.profileToastShowed = false
                this.$bvToast.hide("profile-toast")
            },
            notAcceptedMessage() {
                const userNotAccepted = this.isAuthenticated && this.$auth?.watch?.data?.role === "user" && this.$auth?.watch?.data?.step !== 'accepted';
                if (userNotAccepted) {
                    this.showProfileToast()
                } else {
                    this.hideProfileToast()
                }
            },
            leave() {
                if (this.lastChannelName) {
                    Echo.leaveHard(this.lastChannelName)
                    this.lastChannelName = null
                }
            },
            updateProfile() {
                if (this.isAuthenticated) {
                    this.$auth.fetch().then(res => {
                        this.notAcceptedMessage()
                    })
                }
            },

            listen() {
                const id = this.$auth?.watch?.data?.id
                if (!id) {
                    // console.log("NOT LOGGED IN")
                    this.leave()
                    return
                }

                let channel = `user-alert.${id}`
                if (channel === this.lastChannelName) {
                    return;
                }
                this.leave();
                this.lastChannelName = channel;
                // console.log("JOIN:", this.lastChannelName);

                Echo.join(channel)
                    .listen("Alert", message => {
                        this.eventAlert(message);
                    })
                    .listen('AlertAuction', message => {
                        this.eventAlertAuction(message)
                    })
                    .listen("Message", ({message}) => {
                        this.$store.dispatch('Messages/fetchNotReadMessagesCount')
                        if (!message.user) {
                            return
                        } else this.eventMessage(message)
                    })
                    .listen("MessageDeleted", ({message}) => {
                        this.eventMessageDeleted(message)
                    })
                    .listen("ProfileUpdate", ({message}) => {
                        this.$store.dispatch('Profile/fetchProfile')
                        this.updateProfile()
                    })
                    .listen("Logout", ({message}) => {
                        this.$auth.logout({
                            makeRequest: false,
                        })
                    })
                    .on('pusher:subscription_error', (status) => {
                        // console.log("ERROR", status)
                        console.error(status)
                        Sentry.captureException(status, 'pusher:subscription_error')

                        setTimeout(() => {
                            this.reconnectWebsocket()
                        }, 5000)
                    });
            },
            eventMessage(message) {
                const h = this.$createElement;

                this.$eventHub.$emit("new-message", message);

                const to =
                    userIsAdminOperator()
                        ? {name: "operator.users.show", params: {id: message.user.id, hash: '#user-messages'}}
                        : {name: "profile.messages"}


                const vNodesTitle = h(
                    "router-link",
                    {
                        props: {to},
                    },
                    userIsAdminOperator()
                        ? message.user.profile_label + ":"
                        : "Администрация сайта:"
                );
                let body = message.body

                if (message.body && message.lot) {
                    body = [message.body, this.makeBr(), this.makeBr(), this.makeLotLink(message.lot, false)]
                }
                this.$notify(body, {
                    title: [vNodesTitle],
                    variant: "primary",
                    autoHideDelay: 10000,
                });
            },
            eventMessageDeleted(message) {
                this.$eventHub.$emit("message-deleted", message)
            },
            eventAlert(message) {
                const messageBody = [];

                messageBody.push(message.body);
                if (message.lot) {
                    messageBody.push(this.makeBr());
                    messageBody.push(this.makeLotLink(message.lot))
                }
                this.$notify(messageBody, {
                    title: message.title,
                    variant: message.type,
                    autoHideDelay: message.show_time,
                });
            },

            makeLotLink(lot, toHall) {
                if (!lot) return null;

                const h = this.$createElement;
                const to = routeToLot(lot.id, this.$auth.watch?.data?.role)
                if (toHall) {
                    to.hash = '#lot-hall';
                }

                const lotLink = h(
                    "router-link",
                    {props: {to}},
                    `Перейти к аукциону №${lot.id}, лот №${lot.lot_number}`
                );

                return lotLink;
            },
            makeBr() {
                const h = this.$createElement;
                return h('br');
            },
            eventAlertAuction(message) {
                this.$notify([message.body, this.makeBr(), this.makeLotLink(message.lot, true)], {
                    title: message.title,
                    variant: "danger",
                    toaster: "b-toaster-top-center",
                    noAutoHide: true,
                });
            },

            checkVersion() {
                axios.get('version').then((res) => {
                    const v = res?.data?.version
                    if (v && v != this.currentVersion) {
                        location.reload()
                    }
                })
            }
        },
    };
</script>
<style scoped>
    .overlayed {
        overflow: hidden;
        height: 100vh;
    }
</style>
